// extracted by mini-css-extract-plugin
export var fullHeightState = "_7-7";
export var headerCell = "_7-1";
export var loadingStateCell = "_7-4";
export var rowWrapper = "_7-3";
export var standaloneTable = "_7-8";
export var standaloneTableWithBodyFill = "_7-9";
export var stateCell = "_7-5";
export var table = "_7-0";
export var tableBodyFiller = "_7-6";
export var white = "_7-2";